module.exports = __webpack_public_path__ + "media/never-gonna.d21b725d.mp3";